import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./pageControl.css";
import { setZoomLevel } from "../../redux/actions/setZoomLevelAction";
import useOutside from "../../hooks/useOutside";
import { getFilterState } from "../../functions/filterState/filterState";
import {
    createFilterCanSeeAction,
    createFilterCanSeeProjectAction,
    createFilterCannotSeeProjectsAction,
    getfilterSetCanSeeCompletedActionType,
    getfilterSetCanSeeHiddenActionType,
    getfilterSetCanSeeProjectActionType,
    getfilterSetCannotSeeProjectsActionType
} from "../../redux/actions/filterAction";
import { redo } from "../../redux/actions/TodoManipulation/redoAction";
import { undo } from "../../redux/actions/TodoManipulation/undoAction";
import { useLocation } from "react-router-dom";
import { findAllProjectIdsInTreeList } from "../../utils/tree";
import { filterOverview, isNullOrUndefined } from "../../utils/todo-utils";
import { saveSettings} from "../../redux/actions/Settings/saveSettingAction";
import { setSectionFilters, updateSectionFilter, toggleAllSections, setFilterCount } from "../../redux/actions/sectionFilterActions";

const PageControl = (props) => {
    const dispatch = useDispatch();
    const location = useLocation();
    //const feature = location.pathname.substring(1);
    const feature = "Overview";
    const filterStateName = getFilterState(feature) ?? "overviewFilterState";
    const zoomLevel = useSelector((state) => state.userSettings.zoomLevel);
    const showCompleted = useSelector((state) => state[filterStateName].CanSeeCompleted);
    const showHidden = useSelector((state) => state[filterStateName].CanSeeHidden);
    const projects = useSelector((state) => state.taskList.data);
    const sectionNames = useSelector((state) => state.sectionFilters.sectionNames);
    const filterState = useSelector(state => state[filterStateName]);
    const filteredProjects = filterOverview(projects, filterState, new Date());
    const canUndo = useSelector((state) => state.taskList.canUndo);
    const canRedo = useSelector((state) => state.taskList.canRedo);
    const filterButtonRef = useRef();
    const filterMenuRef = useRef();
    const sectionFilterButtonRef = useRef();
    const sectionFilterMenuRef = useRef();
    const [showFilters, setShowFilters] = useState(false);
    const [showSectionFilters, setShowSectionFilters] = useState(false);
    const [zoom, setZoom] = useState('');
    const showAllSubtasks = useSelector((state) => state.showAllSubtasks);
    const filterCount = useSelector((state) => state.sectionFilters.filterCount);
    const theme = useSelector((state) => state.userSettings.theme);
    const defaultView = useSelector((state) => state.userSettings.defaultView);
    const notifications = useSelector((state) => state.notificationSettings.active);
    const aiAssistant = useSelector((state) => state.userSettings.aiAssistant);


    useOutside(filterMenuRef, filterButtonRef, null, () => {
        setShowFilters(false);
    });
    useOutside(sectionFilterMenuRef, sectionFilterButtonRef, null, () => {
        setShowSectionFilters(false);
    });

    const handleSliderChange = (event) => {
        const newZoomLevel = parseFloat(event.target.value);
        setZoom(newZoomLevel);
        dispatch(setZoomLevel(newZoomLevel));
    };

    const handleSaveZoomLevel = () => {

        const json = {
            aiAssistant: aiAssistant,
            theme: theme,
            defaultView: defaultView,
            zoomLevel: zoom,
            notifications: notifications
        };
        dispatch(saveSettings(json));
    }


    const handleToggle = () => {
        dispatch({ type: "TOGGLE_SHOW_ALL_SUBTASKS" });
    };

    const handleUndo = async () => {
        await dispatch(undo());
    };

    const handleRedo = async () => {
        await dispatch(redo());
    };

    const handleFilterToggle = () => {
        setShowFilters(prevState => !prevState);
        setShowSectionFilters(false); 
    };

    const handleFilterSectionToggle = () => {
        setShowSectionFilters(prevState => !prevState);
        setShowFilters(false); 
    };

    const handleHiddenToggle = () => {
        dispatch(createFilterCanSeeAction(getfilterSetCanSeeHiddenActionType(feature), !showHidden));
    }

    const handleCompletedToggle = () => {
        dispatch(createFilterCanSeeAction(getfilterSetCanSeeCompletedActionType(feature), !showCompleted));
    }

    const handleUnsortedToggle = () => {
        dispatch({ type: 'TOGGLE_UNSORTED_PANEL' });
    }

    const handleAddNewTask = () => {
        dispatch({ type: "TOGGLE_EDIT_MODAL", payload: { todo: 'addItem' } });
    };

    const getProjects = () => {
        let names = [{ key: '0', value: 'All sections', checked: true }];

        for (let i = 0; i < projects.length; i++) {
            if (projects[i].type === 1) {
                const existing = sectionNames.find((o) => o.value === projects[i].title);

                names.push({
                    key: i,
                    id: projects[i].id,
                    value: projects[i].title,
                    checked: existing ? existing.checked : true,
                });
            }
        }

        names.sort((a, b) => a.value.localeCompare(b.value));

        // Ensure 'All sections' is always on top
        const index = names.findIndex((o) => o.value === 'All sections');
        if (index !== -1) {
            const [item] = names.splice(index, 1);
            names.unshift(item);
        }

        dispatch(setSectionFilters(names));

        // Check if any section (excluding 'All sections') is unchecked
        const anyUnchecked = names.slice(1).some((section) => !section.checked);

        if (anyUnchecked) {
            const checkedCount = names.slice(1).filter((section) => section.checked).length;
            dispatch(setFilterCount(checkedCount));
        } else {
            dispatch(setFilterCount(''));
        }
    };



    const handleSectionChange = (checked, index) => {
        dispatch(updateSectionFilter(index, checked));

        const updatedSects = [...sectionNames];
        updatedSects[index].checked = checked;

        let hide = findAllProjectIdsInTreeList(projects, 0);
        let show = [];

        for (let i = 0; i < updatedSects.length; i++) {
            if (!isNullOrUndefined(updatedSects[i].id) && updatedSects[i].checked) {
                const index = hide.findIndex((o) => o === updatedSects[i].id);
                hide.splice(index, 1);
                if (updatedSects[i].id) {
                    show.push(updatedSects[i].id);
                }
            }
        }

        dispatch(createFilterCannotSeeProjectsAction(getfilterSetCannotSeeProjectsActionType(feature), hide));
        dispatch(createFilterCanSeeProjectAction(getfilterSetCanSeeProjectActionType(feature), show, true));

        if (show.length === 0) {
            handleAllSectionsChange(false);
        } else if (show.length === updatedSects.length - 1 && updatedSects[0].checked === false) {
            handleAllSectionsChange(true);
        } else {
            dispatch(setFilterCount(show.length));
        }
    };

    const handleAllSectionsChange = (checked) => {
        dispatch(toggleAllSections(checked));

        const ids = findAllProjectIdsInTreeList(projects, 0);

        if (checked) {
            dispatch(createFilterCannotSeeProjectsAction(getfilterSetCannotSeeProjectsActionType(feature), []));
            dispatch(createFilterCanSeeProjectAction(getfilterSetCanSeeProjectActionType(feature), ids, true));
            dispatch(setFilterCount(''));
        } else {
            dispatch(createFilterCannotSeeProjectsAction(getfilterSetCannotSeeProjectsActionType(feature), ids));
            dispatch(createFilterCanSeeProjectAction(getfilterSetCanSeeProjectActionType(feature), [], true));
            dispatch(setFilterCount(0));
        }
    };

    const handleSectionFilterChange = (event, index) => {
        if (index !== 0) {
            handleSectionChange(event.target.checked, index);
        } else {
            handleAllSectionsChange(event.target.checked);
        }
    };

    const handleZoomLevelChange = (zoomLevel) => {
        setZoom(zoomLevel);

        //updateZoomLevel(zoomLevel);
        dispatch(
            setZoomLevel(zoomLevel)
        );

        updateZoomLevel(zoomLevel)
    }


    const updateZoomLevel = async (zoomLevel) => {
        const json = {
            zoomLevel: zoomLevel
        };

        await dispatch(saveSettings(json));
    }

    useEffect(() => {

        getProjects();

    }, [projects]);

    return (
        <div className="gt-controls">
            <div className="gt-context-menu-wrapper">
                {location.pathname.toLowerCase().trim() === "/overview" && (
                    <button type="button" className="gw-button-outlined gw-button-outlined--s1 gw-button-outlined--secondary"
                        onClick={() => { handleUnsortedToggle() }}
                    >
                        ({filteredProjects.tasks.length}) Unsorted tasks
                    </button>
                )}
                <button
                    className="gw-button gw-button--s1"
                    onClick={() => {
                        handleFilterToggle();
                    }}
                    ref={filterButtonRef}
                >
                    <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref="#globaltasks-svg-filter"></use>
                    </svg>
                    Filters
                </button>
                {showFilters && (
                    <ul
                        className="gt-context-menu"
                        role="menu"
                        aria-orientation="vertical"
                        ref={filterMenuRef}
                    >
                        <li className="gt-context-menu__item" role="menuitem">
                            <div className="gw-group gw-group--space-between">
                                <p>Completed</p>
                                <div className="gw-toggle-checkbox">
                                    <input
                                        type="checkbox"
                                        className="gw-toggle-checkbox__input"
                                        id="toggle-show-completed"
                                        aria-label="Show Completed Tasks"
                                        onChange={handleCompletedToggle}
                                        checked={showCompleted}
                                        style={{width: 'auto'}}
                                    />
                                </div>
                            </div>
                        </li>
                        <li className="gt-context-menu__item" role="menuitem">
                            <div className="gw-group gw-group--space-between">
                                <p>Hidden</p>
                                <div className="gw-toggle-checkbox">
                                    <input
                                        type="checkbox"
                                        className="gw-toggle-checkbox__input"
                                        id="toggle-show-hidden-tasks"
                                        aria-label="Show Hidden Tasks"
                                        onChange={handleHiddenToggle}
                                        checked={showHidden}
                                        style={{width: 'auto'}}
                                    />
                                </div>
                            </div>
                        </li>
                        <li className="gt-context-menu__item" role="menuitem">
                            <div className="gw-group gw-group--space-between">
                                <p>Expand tasks</p>
                                <div className="gw-toggle-checkbox">
                                    <input
                                        type="checkbox"
                                        id="toggle-show-subtasks"
                                        aria-label="expand tasks"
                                        className="gw-toggle-checkbox__input"
                                        onChange={handleToggle}
                                        checked={showAllSubtasks}
                                        style={{width: 'auto'}}
                                    />
                                </div>
                            </div>
                        </li>
                    </ul>
                )}
            </div>
            <div className="gt-context-menu-wrapper">
                <button
                    className="gw-button gw-button--s1"
                    onClick={() => {
                        handleFilterSectionToggle();
                    }}
                    ref={sectionFilterButtonRef}
                >
                    Filter sections {filterCount}
                </button>
                {showSectionFilters && (
                    <ul
                        className="gt-context-menu"
                        role="menu"
                        aria-orientation="vertical"
                        ref={sectionFilterMenuRef}
                        style={{ maxHeight: '51em', overflowY: 'auto' }}
                    >
                            {sectionNames.slice()
                                .map((sect, index) => (
                                    <li className="gt-context-menu__item" role="menuitem" key={index}>
                                    <div className="gw-group gw-group--space-between">
                                        <p>{sect.value}</p>
                                        <div className="gw-toggle-checkbox">
                                            <input
                                                type="checkbox"
                                                id={index}
                                                aria-label={sect.value}
                                                className="gw-toggle-checkbox__input"
                                                onChange={(event) => handleSectionFilterChange(event, index)}
                                                checked={sect.checked}
                                                style={{width: 'auto'}}
                                            />
                                        </div>
                                    </div>
                                    </li>
                                ))};
                    </ul>
                )}
            </div>
            <div className="gt-controls__zoom">

                <button className="gw-icon-button gw-icon-button--icon gw-icon-button--s1" aria-label="zoom out" onClick={() => { if (zoomLevel !== 5) { handleZoomLevelChange(zoomLevel - 1) } }}>
                    <i className="gw-icon-button__icon gw-button__icon--minus gw-icon-button__icon--s1"></i>
                </button>


                <input
                    aria-label="zoom"
                    type="range"
                    className="gt-controls__slider"
                    step="1"
                    min="5"
                    max="20"
                    value={zoomLevel}
                    onChange={handleSliderChange}
                    onBlur={handleSaveZoomLevel }
                />
                <button className="gw-icon-button gw-icon-button--icon gw-icon-button--s1" aria-label="zoom in" onClick={() => { if (zoomLevel !== 20) { handleZoomLevelChange(zoomLevel + 1) } }}>
                    <i className="gw-icon-button__icon gw-button__icon--plus gw-icon-button__icon--s1"></i>
                </button>

            </div>

            <button
                className="gw-icon-button gw-icon-button--icon gw-icon-button--s1"
                aria-label="undo"
                onClick={() => {
                    handleUndo();
                }}
                disabled={!canUndo}
            >
                <i className="gw-icon-button__icon gw-button__icon--undo gw-icon-button__icon--s1"></i>
            </button>
            <button
                className="gw-icon-button gw-icon-button--icon gw-icon-button--s1"
                aria-label="redo" onClick={() => {
                    handleRedo();
                }}
                disabled={!canRedo}
            >
                <i className="gw-icon-button__icon gw-button__icon--redo gw-icon-button__icon--s1"></i>
            </button>
            <button className="gw-button gw-button--primary" aria-label="Add New Task"
                onClick={() => { handleAddNewTask() }}>
                Add task
            </button>
        </div>
    );
};

export default PageControl;
